import React, { useEffect, useState } from "react";

import { ColumnDescription } from "react-bootstrap-table-next";
import Table from "../../../../../Components/Table";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown, faArrowUp } from "@fortawesome/free-solid-svg-icons";
import SpinnerComponent from "../../../../../Components/Loding/Spinner";
import { ListarAcoesVinculadasDesvinculadasPorGrupoController } from "../../../../../Controllers/Geral/AcaoEtapa/AcaoEtapaControllers";
import { IAcoesVinculadasDesvinculadasPorGrupo } from "../../../../../Interfaces/Geral/AcaoEtapa/AcaoEtapaInterfaces";
import useAsyncCallback from "../../../../../hooks/useAsyncCallback";
import {
    DesvincularGrupoAcaoController,
    VincularGrupoAcaoController,
} from "../../../../../Controllers/Geral/Etapas/EtapasControllers";
import { IVincularDesvincularAcaoEtapa } from "../../../../../Interfaces/Geral/Etapas/EtapasInterfaces";

interface AcaoEtapaProps {
    idGrupo: number;
}
export const ETAPAS_ASSISTENCIA_TECNICA = [
    {
        NR_ETAPA: 2,
        CD_ETAPA: 2,
        DS_ETAPA: "Avaliação de Procedência",
    },
    {
        NR_ETAPA: 3,
        CD_ETAPA: 3,
        DS_ETAPA: "Agendamento Vistoria Inicial",
    },
    {
        NR_ETAPA: 4,
        CD_ETAPA: 4,
        DS_ETAPA: "Execução Vistoria Inicial",
    },
    {
        NR_ETAPA: 5,
        CD_ETAPA: 5,
        DS_ETAPA: "Agendar Manutenção",
    },
    {
        NR_ETAPA: 6,
        CD_ETAPA: 6,
        DS_ETAPA: "Execução de Manutenção",
    },
    {
        NR_ETAPA: 7,
        CD_ETAPA: 7,
        DS_ETAPA: "Pesquisa Satisfação",
    },
    {
        NR_ETAPA: 8,
        CD_ETAPA: 8,
        DS_ETAPA: "Fechamaneto de Manutenção",
    },
    {
        NR_ETAPA: 9,
        CD_ETAPA: 9,
        DS_ETAPA: "Validação Atendimento não Procedente",
    },
    {
        NR_ETAPA: 10,
        CD_ETAPA: 10,
        DS_ETAPA: "Dúvidas Técnica",
    },
];

export default function AcaoEtapa(props: AcaoEtapaProps) {
    const [lstAcaoVinculadas, setLstAcaoVinculadas] = useState(
        [] as Array<IAcoesVinculadasDesvinculadasPorGrupo>
    );
    const [lstAcaoDesvinculadas, setLstAcaoDesvinculadas] = useState(
        [] as Array<IAcoesVinculadasDesvinculadasPorGrupo>
    );

    const { execute: VincularAcaoEtapa } = useAsyncCallback(
        async (body: IVincularDesvincularAcaoEtapa) => {
            VincularGrupoAcaoController(body);
        }
    );
    const { execute: DesvincularAcaoEtapa } = useAsyncCallback(
        async (ID_GRUPO: number, ID_ACAO: number) => {
            DesvincularGrupoAcaoController(ID_GRUPO, ID_ACAO);
        }
    );

    const [loading, setLoading] = useState(true);
    const [cdEtapa, setCdEtapa] = useState(0);
    const [idModulo, setIdModulo] = useState(0);

    useEffect(() => {
        if (props.idGrupo !== 0) updateAcaoEtapa(props.idGrupo);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.idGrupo, cdEtapa]);

    function updateAcaoEtapa(idGrupo: number) {
        setLoading(true);
        ListarAcoesVinculadasDesvinculadasPorGrupoController(
            cdEtapa,
            props.idGrupo
        )
            .then((response) => {
                setLstAcaoVinculadas(response.ACOES_VINCULADAS);
                setLstAcaoDesvinculadas(response.ACOES_DESVINCULADAS);
            })
            .finally(() => setLoading(false));
    }

    const columnsAcaoEtapaVinculadas: Array<ColumnDescription> = [
        {
            dataField: "DS_ACAO",
            text: "Ação Vinculadas",
            formatter: RowFuncaoVinculada,
            sort: true,
        },
    ];

    function RowFuncaoVinculada(
        cell: any,
        row: IAcoesVinculadasDesvinculadasPorGrupo
    ) {
        return (
            <div className="d-flex justify-content-between align-items-center row mx-0 my-4">
                <div className="col-12 mb-2">
                    <span className="mb-1">{row.DS_ACAO}</span>
                </div>
                <div className="col-12">
                    <button
                        className="btn btn-sm btn-outline-danger font-weight-bold d-flex align-items-center justify-content-center flex-nowrap w-100"
                        onClick={() => {
                            DesvincularAcaoEtapa(
                                props.idGrupo,
                                row.ID_ACAO
                            ).finally(() => {
                                updateAcaoEtapa(props.idGrupo);
                            });
                        }}
                    >
                        <FontAwesomeIcon
                            icon={faArrowDown}
                            size="lg"
                            className="mr-2"
                        />{" "}
                        Desvincular
                    </button>
                </div>
            </div>
        );
    }

    const columnsAcaoEtapaDesvinculadas: Array<ColumnDescription> = [
        {
            dataField: "DS_ACAO",
            text: "Ação Desvinculadas",
            formatter: RowFuncaoDesvinculada,
            sort: true,
        },
    ];

    function RowFuncaoDesvinculada(
        cell: any,
        row: IAcoesVinculadasDesvinculadasPorGrupo
    ) {
        return (
            <div className="d-flex justify-content-between align-items-center row mx-0 my-4">
                <div className="col-12 mb-2">
                    <label className="mb-1">{row.DS_ACAO}</label>
                </div>
                <div className="col-12">
                    <button
                        className="btn btn-sm btn-outline-success font-weight-bold d-flex align-items-center justify-content-center flex-nowrap w-100"
                        onClick={() => {
                            VincularAcaoEtapa({
                                ID_GRUPO: props.idGrupo,
                                ID_ACAO_ETAPA_GRUPO: 0,
                                ID_ETAPA_ATENDIMENTO: row.ID_ACAO,
                                ID_ETAPA_CATEGORIA_ATENDIMENTO: cdEtapa,
                            }).finally(() => {
                                updateAcaoEtapa(props.idGrupo);
                            });
                        }}
                    >
                        <FontAwesomeIcon
                            icon={faArrowUp}
                            size="lg"
                            className="mr-2"
                        />{" "}
                        Vincular
                    </button>
                </div>
            </div>
        );
    }

    return !loading ? (
        <>
            <h3>Bloquear Ação por etapa</h3>
            <select
                className={`form-control placeholder-dark-50 w-100`}
                onChange={(e) => setIdModulo(Number(e.target.value))}
                defaultValue={idModulo}
            >
                <option value="0">Selecione um módulo</option>
                <option value="1">Assistência Técnica</option>
            </select>
            {idModulo === 1 ? (
                <select
                    className={`form-control placeholder-dark-50 w-100 mt-6`}
                    onChange={(e) => setCdEtapa(Number(e.target.value))}
                    defaultValue={cdEtapa}
                >
                    <option value="0">Selecione uma etapa</option>
                    {ETAPAS_ASSISTENCIA_TECNICA.map((etapa) => {
                        return (
                            <option value={etapa.NR_ETAPA}>
                                {etapa.DS_ETAPA}
                            </option>
                        );
                    })}
                </select>
            ) : null}
            <div className="Row2 flex-lg-row-fluid d-flex flex-column flex-lg-row mt-5">
                <div className="col-12 col-lg-6">
                    <Table
                        keyField="ID_ACAO"
                        columns={columnsAcaoEtapaVinculadas}
                        data={lstAcaoVinculadas}
                        classes="tableClass"
                        bodyClasses="bodyClass"
                        sizePerPage={5}
                    />
                </div>
                <div className="col-12 col-lg-6">
                    <Table
                        keyField="ID_ACAO"
                        columns={columnsAcaoEtapaDesvinculadas}
                        data={lstAcaoDesvinculadas}
                        classes="tableClass"
                        bodyClasses="bodyClass"
                        sizePerPage={5}
                    />
                </div>
            </div>
        </>
    ) : (
        <SpinnerComponent />
    );
}
